import { useNavigate, useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../application/config/config';
import { useEffect, useState } from "react";
import Fetch from "../../../core/util/core/Fetch";

function Form() {
  const { id } = useParams();
  const [form, setForm] = useState();
  const navigate = useNavigate();
  const [formContent, setFormContent] = useState(<>Carregando...</>);

  const endpointBackend = config.endpoints.backend;
  const path = '/governanceroom/filetypehelps/';
  const paths = {
    endpointSave: endpointBackend + 'governanceroom/filetypes/save',
    endpointGetById: endpointBackend + 'governanceroom/filetypes/getByIdHelp',
    urlGoBack: path + 'list',
    pathView: path + 'view'
  }


  const periodicityOptions = [
    { label: 'Mensal', value: 'Mensal' },
    { label: 'Anual', value: 'Anual' },
    { label: 'Semestral', value: 'Semestral' },
    { label: 'Quadrimestral', value: 'Quadrimestral' },
    { label: 'Arquivo único', value: 'Arquivo único' }
  ];

  const sphereOptions = [
    { label: 'Municipal', value: 'Municipal' },
    { label: 'Estadual', value: 'Estadual' },
    { label: 'Nacional', value: 'Nacional' }
  ];

  const getForm = (values) => {

    const labels = {
      labelTitleEdit: "Editar Ajuda",
      labelTitleView: 'Visualizar Ajuda',
    }

    const form = {
      validateOnChange: true,
      fields: [
        {
          name: 'file_category',
          type: 'text',
          label: 'Categoria',
          validations: {
            required: false
          },
          readOnly: true,
          columnSize: 6
        },
        {
          name: 'file_type',
          type: 'text',
          label: 'Tipo do Arquivo',
          validations: {
            required: false
          },
          readOnly: true,
          columnSize: 6
        },
        {
          name: 'periodicity',
          type: 'select',
          label: 'Periodicidade',
          options: periodicityOptions,
          validations: {
            required: false
          },
          columnSize: 6
        },
        {
          name: 'sphere',
          type: 'select',
          label: 'Esfera',
          options: sphereOptions,
          validations: {
            required: false
          },
          columnSize: 6
        },
        {
          name: 'archive_help',
          type: 'textarea',
          label: 'Ajuda',
          validations: {
            required: false
          },
          columnSize: 12
        }
      ],
      ...paths,
      ...labels
    }
    form.values = values;
    return form;
  }
  useEffect(() => {
    const load = async () => {
      let values = {};
      
      if(id){
        values = await Fetch.post(paths.endpointGetById, {id});
      }

      const form = getForm(values);
      setForm(form);
      setFormContent(
        <div>
          <CustomFormContainer
            form={form}
            content={<CustomForm form={form} />}
          />
        </div>
      );
    }
    load();
  }, [])

  return (
    <div>
      {formContent}
    </div>
  );
}
export default Form;
